import React from 'react';
import { motion } from 'framer-motion';
import styles from './DataTable.module.css';

export interface DataTableProps {
    title?: string;
    description?: string;
    headers: string[];
    rows: string[][];
}

const DataTable: React.FC<DataTableProps> = ({
    title,
    description,
    headers,
    rows,
}) => {
    return (
        <motion.div
            className={styles.dataTableContainer}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
        >
            {(title || description) && (
                <div className={styles.dataTableHeader}>
                    {title && <h3 className={styles.dataTableTitle}>{title}</h3>}
                    {description && <p className={styles.dataTableDescription}>{description}</p>}
                </div>
            )}

            <div className={styles.dataTableWrapper}>
                <table className={styles.dataTableElement}>
                    <thead>
                        <tr>
                            {headers.map((header, index) => (
                                <th
                                    key={index}
                                    scope="col"
                                    className={styles.dataTableHeadCell}
                                    dangerouslySetInnerHTML={{ __html: header }}
                                />
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={rowIndex} className={styles.dataTableBodyRow}>
                                {row.map((cell, cellIndex) => (
                                    <td
                                        key={cellIndex}
                                        className={styles.dataTableCell}
                                        dangerouslySetInnerHTML={{ __html: cell }}
                                    />
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </motion.div>
    );
};

export default DataTable;
